











































































































































































import {
  SfAccordion, SfIcon, SfImage, SfList, SfMenuItem, SfSidebar, SvgImage, SfLink, SfButton, SfModal, SfBreadcrumbs
} from '~/components';
import {
  defineComponent, useRouter, useContext, computed, onMounted, onBeforeUnmount,
} from '@nuxtjs/composition-api';
import { useUiState, useUser, useWebsiteCode } from '~/composables';
import { CategoryTree } from '~/modules/GraphQL/types';
import { useMobileCategoryTree } from './logic';

import transparentPlaceholder from '~/styles/images/transparent_placeholder.svg';
import userGetters from "~/modules/customer/getters/userGetters";
import CitySelectorLabel from "~/components/GeoCitySelector/CitySelectorLabel.vue";
import CitySelectorListModal from "~/components/GeoCitySelector/CitySelectorListModal.vue";
import { useCitySelectorStore } from '~/components/GeoCitySelector/stores/citySelector'
import { ensureTrailingSlash } from '~/helpers/ensureTrailingSlash';
import { isCoutureExternalUrl } from '~/helpers/couture';
import { formatAbsoluteUrlToLocal } from '~/utilities/helpers';

export default defineComponent({
  components: {
    CitySelectorListModal,
    CitySelectorLabel,
    SfBreadcrumbs,
    SfModal,
    SfAccordion,
    SfSidebar,
    SfList,
    SfMenuItem,
    SfIcon,
    SfImage,
    SvgImage,
    SfLink,
    SfButton
  },
  props: {
    categoryTree: {
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { isRu } = useWebsiteCode();
    const { isMobileMenuOpen, toggleMobileMenu, toggleDesktopMenu, toggleLoginModal } = useUiState();
    const router = useRouter();
    const app = useContext();
    const { user, isAuthenticated } = useUser();
    const { i18n, localeRoute, localePath } = useContext();
    const citySelectorStore = useCitySelectorStore();

    const getCategoryLink = (url: string) => decodeURIComponent(
      localePath(formatAbsoluteUrlToLocal(url, app.$config))
    );

    const welcomeText = computed(() => {
      let userName;

      if(userGetters.getFirstName(user.value) === '--') {
        userName = null
      } else {
        userName = user.value
          ? user.value.firstname
          : userGetters.getFirstName(user.value);
      }
      if(userName) {
        return `Добро пожаловать, ${userName}`;
      }
      return `Добро пожаловать`;
    });

    const categoryTree = computed(() => props.categoryTree);

    const navigate = (category: CategoryTree) => {
      toggleMobileMenu();

      if (category.url_type === 'external' && category.url) {
        if (process.client) {
          window.location.assign(category.url);
        }
        return;
      }

      router.push(ensureTrailingSlash(getCategoryLink(category.url)));
    };

    const getMobileMenuItemLink = (category: CategoryTree): string | null => {
      if (category.url_type !== 'external' || !category.url) {
        return null;
      }

      if (isCoutureExternalUrl(category.url)) {
        return null;
      }

      return category.url;
    };

    const {
      current: currentCategory, history, currentItems, onGoCategoryUp, onGoCategoryDown,
    } = useMobileCategoryTree();

    const itemsIncludedInMenu = computed(() => {
      const topLevelItems = categoryTree.value;
      const items = currentItems.value || topLevelItems;

      return items.map(root => {
        const rootCopy = { ...root };

        rootCopy.children = (rootCopy.children || []).map(child => {
          const copy = { ...child };

          const isSpecial = copy.css_classes?.includes('special-category');

          const hasSubcategory = (copy.children || []).some(
            sub => !sub.url || sub.children?.length > 0
          );

          if (hasSubcategory && !isSpecial) {
            copy.hasSubcategory = true;
            copy.css_classes = copy.css_classes
              ? copy.css_classes + ' has-subcategory'
              : 'has-subcategory';
          }

          return copy;
        });

        return rootCopy;
      });
    });

    const canShowViewAll = computed(() => {
      return currentCategory.value && history.value.length <= 1;
    });

    const openMobileSearch = () => {
      document.getElementById('mobileSearch').classList.add('header-on-top', 'search-opened');
      document.getElementById('search').focus();
    };

    const handleAccountClick = async () => {
      if(isAuthenticated.value) {
        await router.push(app.localeRoute({name: 'customer'}));
      } else {
        toggleLoginModal();
      }
      toggleMobileMenu();
    };

    const handleStoreClick = async () => {
      await router.push(app.localeRoute('/togas-boutiques'));
      toggleMobileMenu();
    };

    const closeMobileMenu = async () => {
      toggleMobileMenu();

      const mobileMenuSidebar = document.getElementsByClassName(
        'mobile-menu-sidebar'
      )[0];

      mobileMenuSidebar.classList.remove('hide');
    };

    const handlePhoneClick = async () => {
      emit('open-contact-modal');
      toggleMobileMenu();
    };

    const handleOpenCityModal = () => {
      toggleMobileMenu();
      citySelectorStore.handleCitySelectorModalClick();
    };

    const onGoCategoryUpTwo = () => {
      const stepsBack = history.value.length >= 3 ? 3 : (history.value.length >= 2 ? 2 : 0);

      if (stepsBack > 0) {
        setTimeout(() => { history.value.splice(-stepsBack, stepsBack) }, 500)
      } else {
        setTimeout(() => { history.value = []; }, 500)
      }
    };

    let navigationMediaQuery;

    const navigationSwitcher = (event) => {
      if (typeof document !== 'undefined') {
        const mobileMenu = document.querySelector('.sf-sidebar__aside');

        if (mobileMenu) {
          if (event.matches) {
            console.log('Switching to desktop menu');
            toggleDesktopMenu();
            toggleMobileMenu();
          }
        }
      }
    }

    onMounted(() => {
      if (typeof window !== 'undefined') {
        navigationMediaQuery = window.matchMedia('(min-width: 1024px)');
        navigationMediaQuery.addEventListener('change', navigationSwitcher);
        navigationSwitcher(navigationMediaQuery);
      }
    });

    onBeforeUnmount(() => {
      if (typeof window !== 'undefined' && navigationMediaQuery) {
        navigationMediaQuery.removeEventListener('change', navigationSwitcher);
      }
    })

    return {
      isAuthenticated,
      handleAccountClick,
      handleStoreClick,
      currentCategory,
      onGoCategoryUp,
      onGoCategoryDown,
      history,
      navigate,
      getMobileMenuItemLink,
      isMobileMenuOpen,
      toggleMobileMenu,
      toggleDesktopMenu,
      closeMobileMenu,
      itemsIncludedInMenu,
      openMobileSearch,
      transparentPlaceholder,
      welcomeText,
      handlePhoneClick,
      handleOpenCityModal,
      onGoCategoryUpTwo,
      citySelectorStore,
      canShowViewAll,
      getCategoryLink,
      isRu,
    };
  },
  methods: {
    async handleItemClick(category) {
      const sidebarAside = document.querySelector('.sf-sidebar__aside');

      if (sidebarAside) { sidebarAside.scrollTo(0, 0) }

      localStorage.setItem('selectedCategoryLabel', category.label);

      let link = null;

      if (category.url_type === 'external') {
        link = category.url;
      } else if (category.url_type === 'category') {
        link = category.url
          ? ensureTrailingSlash(this.getCategoryLink(category.url))
          : null;
      }

      localStorage.setItem('selectedCategoryLink', link);

      if (category.children && category.children.length > 0) {
        this.onGoCategoryDown(category);
      } else {
        await this.delay(1000);
        this.navigate(category);
      }

    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  }
});
